function isValidPhoneNumberMasked(value) {
    return /^\(\d{2}\)\s\d{4,5}-\d{4}$/.test(value);
}
export function isValidPhoneNumber(value) {
    if (!value)
        return false;
    if (isValidPhoneNumberMasked(value)) {
        return true;
    }
    const numeric = value.replace(/\D/g, '');
    return numeric.length === 10 || numeric.length === 11;
}
